var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-936.394 -163.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    transform: "translate(936.394 163.352)",
    fill: "#548af7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.259 -32.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.577,14.554a2.277,2.277,0,1,1,2.256-2.277A2.277,2.277,0,0,1,35.577,14.554Zm0-4a1.727,1.727,0,1,0,1.707,1.727A1.727,1.727,0,0,0,35.577,10.55Z",
    transform: "translate(851.509 189.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.745,55.876A4.832,4.832,0,0,1,24.5,55.6a8.191,8.191,0,0,0-2.354-.449,9.382,9.382,0,0,0-2.364.389c-.815.213-1.4.366-1.78.074a.864.864,0,0,1-.294-.738,4.437,4.437,0,0,1,8.874,0,.977.977,0,0,1-.327.849.824.824,0,0,1-.513.15Zm-3.6-1.274a8.573,8.573,0,0,1,2.513.474c.541.164,1.1.333,1.27.209.067-.051.1-.2.1-.412a3.888,3.888,0,0,0-7.775,0c0,.091.011.25.08.3.164.126.743-.025,1.305-.172A9.971,9.971,0,0,1,22.147,54.6Z",
    transform: "translate(864.939 154.617)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.49ac505234c10602783c5f9870ba5386.svg";
export { ForwardRef as ReactComponent };